import React, { CSSProperties, ReactNode } from "react";

type Severity = "critical" | "warning";

type Props = {
    severity: Severity;
    title: string;
    sub?: string;
    icon?: string;
    action?: ReactNode;
};

const iconColorBySeverity: Record<Severity, string> = {
    critical: "var(--vb-error-500)",
    warning: "#E2A100",
};

const defaultIconBySeverity: Record<Severity, string> = {
    critical: "warning",
    warning: "warning",
};

export const StatusBanner: React.FC<Props> = ({ severity, title, sub, icon, action }) => (
    <div className={`status-banner status-banner--${severity}`} style={bannerStyle}>
        <div className="status-banner__l">
            <span
                className="material-symbols-outlined"
                style={{ fontSize: 22, color: iconColorBySeverity[severity] }}
            >
                {icon ?? defaultIconBySeverity[severity]}
            </span>
            <div>
                <div className="title">{title}</div>
                {sub !== undefined && sub !== "" ? <div className="sub">{sub}</div> : null}
            </div>
        </div>
        {action}
    </div>
);

const bannerStyle: CSSProperties = { marginBottom: 16 };
